import React from "react";

export default function BlankTr() {
  return (
    <tr>
      <td style={{ height: 5 }}></td>
    </tr>
  );
}
